export default Object.freeze({
  SELECT_TYPE: 'select',
  TEXT_SEARCH_TYPE: 'text_search',
  RANGE_TYPE: 'range',
  MULTI_SELECT_TYPE: 'hub-select',

  DEFAULT_SEARCH_FIELD_NAME: 'fulltext',
});
